import React from 'react';

function CircleDollar(props) {
  return (
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M11 6.1875V7.5625" stroke="#0781B5" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M11 14.4375V15.8125" stroke="#0781B5" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M11 19.25C15.5563 19.25 19.25 15.5563 19.25 11C19.25 6.44365 15.5563 2.75 11 2.75C6.44365 2.75 2.75 6.44365 2.75 11C2.75 15.5563 6.44365 19.25 11 19.25Z"
        stroke="#0781B5"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.9375 14.4375H12.0312C12.4871 14.4375 12.9243 14.2564 13.2466 13.9341C13.5689 13.6118 13.75 13.1746 13.75 12.7188C13.75 12.2629 13.5689 11.8257 13.2466 11.5034C12.9243 11.1811 12.4871 11 12.0312 11H9.96875C9.51291 11 9.07574 10.8189 8.75341 10.4966C8.43108 10.1743 8.25 9.73709 8.25 9.28125C8.25 8.82541 8.43108 8.38824 8.75341 8.06591C9.07574 7.74358 9.51291 7.5625 9.96875 7.5625H13.0625"
        stroke="#0781B5"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default CircleDollar;
